import MobileHeader from "./MobileHeader";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { LuBell as FiBell, LuTrophy as FiAward } from "react-icons/lu";
import Sidebar from "./Sidebar";
import { useUser } from "../contexts/UserContext";
import { rows, useRecord } from "../utils/appData";
export function State({ loading, error, empty, children }) {
  if (loading)
    return (
      <p
        role="status"
        className="zy-empty px-2.5 py-8 text-center text-slate-500 dark:text-[#a4b0bc]"
      >
        Loading…
      </p>
    );
  if (error)
    return (
      <p
        role="alert"
        className="zy-error my-3 rounded-[10px] bg-red-100 p-3 text-red-700 dark:bg-red-950 dark:text-red-200"
      >
        {error}
      </p>
    );
  if (empty)
    return (
      <p className="zy-empty px-2.5 py-8 text-center text-slate-500 dark:text-[#a4b0bc]">
        {children || "Nothing here yet."}
      </p>
    );
  return null;
}
export default function AppPage({
  title,
  subtitle,
  children,
  headerActions,
  hideMobileHeading = false,
  mainClassName = "",
}) {
  const { currentUser } = useUser();
  const { pathname } = useLocation();
  const { data } = useRecord(
    currentUser?.uid ? `Notifications/${currentUser.uid}` : null,
  );
  const unread = rows(data).filter((n) => n.read !== true).length;
  return (
    <div className="zy-app flex h-[100dvh] bg-[var(--zylen-page-background,#f6f8fa)] text-[#172831] dark:text-[#f3f6f8]">
      <MobileHeader title={title} rightElement={headerActions} />
      <Sidebar />
      <main className={`zy-main min-h-0 min-w-0 flex-1 overflow-y-auto px-6 pt-5 pb-24 md:pb-20 ${mainClassName}`}>
        <header
          className={`zy-header [&_.zy-button]:rounded-full mb-7 flex items-center justify-between gap-2 md:gap-4 [&_h1]:text-[30px] [&_h1]:font-extrabold [&_h1]:tracking-[-0.8px] ${hideMobileHeading ? "max-md:!hidden" : ""}`}
          data-home={pathname === "/dashboard" ? "true" : "false"}
        >
          <div>
            <p className="zy-eyebrow mb-1.5 text-[10px] font-extrabold tracking-[2px] text-[#327691] dark:text-[#5FAFCB]">
              YOUR CREATIVE SPACE
            </p>
            <h1>{title}</h1>
            {subtitle && (
              <p className="zy-muted text-sm text-slate-500 dark:text-[#a4b0bc]">
                {subtitle}
              </p>
            )}
          </div>
          <div className="zy-actions flex flex-wrap items-center gap-3">
            {headerActions ?? (
              <>
                <Link
                  className="zy-button inline-flex min-h-11 cursor-pointer items-center justify-center gap-2 rounded-[14px] px-[17px] py-[11px] text-sm font-semibold disabled:cursor-wait disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#49a3c9] border border-slate-200 bg-white dark:border-[#363e46] dark:bg-[#23272c] secondary"
                  to="/apply-challenge"
                >
                  <FiAward /> <span>Challenge</span>
                </Link>
                <Link
                  className="zy-icon-button relative inline-flex h-11 w-11 min-h-11 shrink-0 items-center justify-center rounded-full border border-slate-200 bg-white p-2.5 text-inherit dark:border-[#363e46] dark:bg-[#23272c]"
                  to="/notifications"
                  aria-label={`Notifications, ${unread} unread`}
                >
                  <FiBell size={22} />
                  {unread > 0 && (
                    <b className="zy-badge absolute -right-[5px] -top-[7px] rounded-[20px] bg-[#dc3545] px-1.5 py-0.5 text-[11px] text-white">
                      {unread > 99 ? "99+" : unread}
                    </b>
                  )}
                </Link>
              </>
            )}
          </div>
        </header>
        {children}
      </main>
    </div>
  );
}
